import cartCreateMutation from './cartCreateMutation'
import cartLinesAddMutation from './cartLinesAddMutation'
import cartLinesUpdateMutation from './cartLinesUpdateMutation'
import cartAttributesUpdateMutation from './cartAttributesUpdateMutation'
import cartBuyerIdentityUpdateMutation from './cartBuyerIdentityUpdateMutation'
import customerAddressUpdateMutation from './customerAddressUpdateMutation'
import customerAddressDeleteMutation from './customerAddressDeleteMutation'
import customerAddressAddMutation from './customerAddressAddMutation'
import customerUpdateMutation from './customerUpdateMutation'

export {
  cartCreateMutation,
  cartLinesAddMutation,
  cartLinesUpdateMutation,
  cartAttributesUpdateMutation,
  cartBuyerIdentityUpdateMutation,
  customerAddressUpdateMutation,
  customerAddressDeleteMutation,
  customerAddressAddMutation,
  customerUpdateMutation
}
